import InvoiceDetails from './InvoiceDetails';

export default InvoiceDetails;
